<template>
  <va-create-layout>
    <installations-form :title="title" :item="item"></installations-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
